import SimpleDate from 'app/common/classes/simple-date'
import toFixedValue from 'app/common/lib/toFixedValue'
import { converRowEncashments, converRowSummary, convertStatuses } from './convertResults'
import { EncashmentsRowItemType, ReportEncashmentsData } from 'app/dataTypes/reports/data'


export const dateFormat = 'YYYY-MM-DD' as const
export const dateTimeFormat = 'YYYY-MM-DD hh:mm:ss' as const

export type ApiRowSummary = {
  school_id: number,
  school_title: string,
  building_title: string,
  sale_point_id: number,
  sale_point_title: string,
  status: number,
  comment: string | null,
  balance_at_the_beginning: number,     // остаток на начало смены
  revenue: number,                      // выручка
  collected: number,                    // сдано
  balance_at_the_end: number,                // остаток на конец смены
  encashments_count: number                    // кол-во инкассаций
}

export type ApiRowEncashment = {
  id: 1,
  time: string,   //"2025-03-13T11:15:35+03:00"
  balance_at_the_beginning: number,
  revenue: number,
  collected: number,
  balance_at_the_end: number
}

type ApiRowItemType = {
  summary: ApiRowSummary
  encashments: Array<ApiRowEncashment>
}

export type ApiStatusesType = {                            // сумма по каждому статусу
  "-1": number,
  "0": number,
  "1": number,
  "2": number
}

export type ApiResultEncashments = {
  date: string
  rows: Array<ApiRowItemType>              // набор строк по каждой точке продаж
  summary: {                               // сводные данные
    balance_at_the_beginning: number,
    revenue: number,
    collected: number,
    balance_at_the_end: number,
    statuses: ApiStatusesType                           // сумма по каждому статусу
  }
}

export const statusParams = {
  "0": 'cashAccepted', //'Наличные приняты'
  "1": 'cashRefused', //'Отказано'
  "2": 'waitingForCash', //'Ожидает принятия наличных'
  "-1": 'cashNotDeposited'//'Наличные не сданы'
}


export const convertResultEncashments = (res: ApiResultEncashments): ReportEncashmentsData => {
  const {
    date,
    rows,
    summary,
  } = res

  const rowsData = rows.map(row => {
    const {
      summary,
      encashments
    } = row
    const res: EncashmentsRowItemType = {
      encashmentsSummary: converRowSummary(summary),
      encashmentsDetails: converRowEncashments(encashments)
    }
    return res
  })

  const {
    balance_at_the_beginning: balanceAtTheBeginning,
    revenue,
    collected,
    balance_at_the_end: balanceAtTheEnd,
    statuses,
  } = summary

  return {
    date: new SimpleDate(date, dateFormat),
    rows: rowsData,
    totalSummary: {
      balanceAtTheBeginning: toFixedValue(balanceAtTheBeginning),
      revenue: toFixedValue(revenue),
      collected: toFixedValue(collected),
      balanceAtTheEnd: toFixedValue(balanceAtTheEnd),
      statuses: convertStatuses(statuses),
    }
  }
}
